import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL + '/api',
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 30000,
});

// Request interceptor - get token fresh each time
api.interceptors.request.use(
    (config) => {
        // Get token at request time, not at file load time
        const access_token = localStorage.getItem("access_token");
        if (access_token) {
            config.headers.Authorization = `Bearer ${access_token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            console.error('Unauthorized - Check your token');
        }
        return Promise.reject(error);
    }
);

export const meetingService = {
    createMeeting: (data) => api.post('/meetings', data),
    getMeetings: () => api.get('/meetings'),
    getMeetingById: (id) => api.get(`/meetings/${id}`),
    getMeetingSummary: (id) => api.get(`/meetings/${id}/summary`),
    deleteMeeting: (id) => api.delete(`/meetings/${id}`),
    updateMeetingStatus: (id, status) => api.patch(`/meetings/${id}/status`, { status }),
};

export const userService = {
    getProfile: () => api.get('/users/profile'),
};

export default api;